import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Dropdown, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Toggle from 'react-toggle';

import ScheduleGroupStaffs from './Elements/ScheduleGroupStaffs';
import getLocale from '../../i18n/getLocale';


class SchedulePlanningSimulation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      approve: false,
      justification: null,
      id: null,
      schedule_availability_id: null,
      status_str: null,
      status: null,
      aircraft: null,
      base: null,
      date: null,
      available: null,
      interruption_start: null,
      unavailable_reason: null,
      deadline_preview: null,
      flight_following: null,
      flight_following_reason: null,
      flight_following_date: null,
      flight_following_preview: null,
      sigmec_id: null,
      observations: null,
      schedule_initials_select: [],
      captains_select: [],
      copilots_select: [],
      flight_attendants_select: [],
      flight_following_reasons_select: [],
      staffs_sigmec_select: [],
      schedule_group_staffs: [],
      schedule_warnings: [],
      schedule_logs: [],
      extra_crew: false,
      modal_alerts: false,
      staff_alerts: {},
      global_alerts: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.setFinish = this.setFinish.bind(this);
    this.warnings = this.warnings.bind(this);
    this.modalAlerts = this.modalAlerts.bind(this);
    this.add = this.add.bind(this);
    this.addCaptain = this.addCaptain.bind(this);
    this.addCopilot = this.addCopilot.bind(this);
    this.addFlightAttendant = this.addFlightAttendant.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = true;
    } else {
      var value = false;
    }
    change[name] = value;
    this.setState({contract_id: null, aircraft_id: null});
    this.setState(change);
  }
  
  //Ao trocar aeronava, listamos contratos da mesma..
  handleSelectAircraftChange(name, event) {
    var change = {};
    var self = this;
    change['contract_id'] = null;
    if(event == null) {
      change[name] = null;
      self.setState({ contracts_select: [] });
    } else {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/contrato/aeronave/select/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.setState({
              contracts_select: responseJson.data,
            });
          }
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }); /* Overlay */
      });
    }
    this.setState(change);
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData(1));
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/info/simulacao', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            extra_crew: 0,
            aircraft: null,
            contract: null,
            base: null,
            schedule_initials_select: responseJson.data.schedule_initials_select,
            captains_select: responseJson.data.captains_select,
            copilots_select: responseJson.data.copilots_select,
            flight_attendants_select: responseJson.data.flight_attendants_select,
            bases_select: responseJson.data.bases_select,
            aircrafts_select: responseJson.data.aircrafts_select,
            captain_duties_select: responseJson.data.captain_duties_select,
            captain_duty_id: responseJson.data.pre_select_captain,
            copilot_duties_select: responseJson.data.copilot_duties_select,
            copilot_duty_id: responseJson.data.pre_select_copilot,
            flight_attendant_duties_select: responseJson.data.flight_attendant_duties_select,
            flight_attendant_duty_id: responseJson.data.pre_select_flight_attendant,
            date: responseJson.data.date,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  // Fetch salvando a edição
  setFinish(event) {
    var data = new Date();
    var day = data.getDate();
    if (day < 10 ) {
      day = '0' + day;
    }
    var month = (data.getMonth()+1);
    if (month < 10 ) {
      month = '0' + month;
    }
    var hours = data.getHours();
    if (hours < 10 ) {
      hours = '0' + hours;
    }
    var minutes = data.getMinutes();
    if (minutes < 10 ) {
      minutes = '0' + minutes;
    }
    var finish = day + '/' + (month) + '/' + data.getFullYear() + ' ' + hours + ':' + minutes;
    this.setState({finish: finish});
  }


  warnings() {
    var self = this;
    var url = "/escala/programacao/alertas/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({approve: false, modal_alerts: true});
          self.modalAlerts(responseJson.data);
          self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      });
    });
  }

  deleteRow(key) {
    var data = this.state.schedule_group_staffs;
    data.map(function(dado, index){
      if (index == key) {
        data.splice(index, 1);
      }
    });
    this.setState({schedule_group_staffs: data});
  }


  add(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      contract_id: this.state.contract_id,
      aircraft_id: this.state.aircraft_id,
      extra_crew: this.state.extra_crew,
      base_id: this.state.base_id,
      date: this.state.date,
      schedule_group_staffs: this.state.schedule_group_staffs,
      start: this.state.start,
      finish: this.state.finish,
      schedule_initial_id: this.state.schedule_initial_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/simular/escala/programacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
            self.setState({modal_alerts: true});
            self.modalAlerts(responseJson.data);
            self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addCaptain(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_group_staffs: this.state.schedule_group_staffs,
      staff_id: this.state.captain_id,
      duty_id: this.state.captain_duty_id,
      role: 'captain',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/simulacao/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({schedule_group_staffs: responseJson.data});
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
    }).catch((error) => {
        console.error(error);
      });
    });
  }
  addCopilot(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_group_staffs: this.state.schedule_group_staffs,
      staff_id: this.state.copilot_id,
      duty_id: this.state.copilot_duty_id,
      role: 'copilot',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/simulacao/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({schedule_group_staffs: responseJson.data});
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
    }).catch((error) => {
        console.error(error);
      });
    });
  }

  addFlightAttendant(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_group_staffs: this.state.schedule_group_staffs,
      staff_id: this.state.flight_attendant_id,
      duty_id: this.state.flight_attendant_duty_id,
      role: 'flight_attendant',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/simulacao/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({schedule_group_staffs: responseJson.data});
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
    }).catch((error) => {
        console.error(error);
      });
    });
  }

  modalAlerts(data) {

    if (data.staff) {
      this.setState({staff_alerts: data.staff});

    }
    if (data.global) {
      this.setState({global_alerts: data.global});
    }

  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
        {(this.state.extra_crew == 0) ? 
            <h3 className="page-title pull-left">{this.locale.Escalas.SimulacaoEscalaDiaria.titulo}</h3>
            :
            <h3 className="page-title pull-left">{this.locale.Escalas.SimulacaoEscalaDiaria.tituloSimulacaoEscalaDiariaTripulacaoExtra}</h3>
        }
        <div className="clearfix"></div>
        <hr />
        <div className="row">
        <div className="col-md-4">
            <div className="form-group">
            <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formulario.Data}:</label>
            <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" required />
            </div>
        </div>
        <div className="col-md-4">
            <div className="form-group">
            <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formulario.Prefixo}:</label>
            <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectAircraftChange.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_select}
                required
            />
            </div>
        </div>
        <div className="col-md-4">
            <div className="form-group">
            <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formulario.Contrato}:</label>
            <Select
                className="form-field-name"
                name="contract_id"
                value={this.state.contract_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'contract_id')}
                options={this.state.contracts_select}
                required
            />
            </div>
        </div>
        </div>
        <hr/>
        <div className="row">
            <div className="col-md-4">
                <div className="form-group">
                <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formulario.HorarioDeApresentacao}:</label>
                <InputMask value={this.state.start}  maskChar={null} name="start" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder="" required />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formulario.HorarioDeTerminoDaJornada}:</label>
                <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder="" />
                </div>
            </div>
            <div className="col-md-1">
                <div className="form-group">
                    <button type="button" onClick={() => this.setFinish()} className="btn btn-inline btn-default btn-block"><i className="fa fa-fw fa-calendar"></i></button>
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formulario.Situacao}:</label>
                <Select
                    className="form-field-name"
                    name="schedule_initial_id"
                    value={this.state.schedule_initial_id}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChange.bind(this, 'schedule_initial_id')}
                    options={this.state.schedule_initials_select}
                    required
                />
                </div>
            </div>
        </div>
        <hr/>
        <div className="row">
          <form onSubmit={this.addCaptain} className="col-md-4">
              <div className="row">
                  <div className="col-md-5">
                      <div className="form-group">
                          <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formularioAdicionarComandante.Comandante}:</label>
                          <Select
                          className="form-field-name"
                          name="captain_id"
                          value={self.state.captain_id}
                          searchable={true}
                          placeholder={''}
                          onChange={self.handleSelectChange.bind(self, 'captain_id')}
                          options={self.state.captains_select}
                          required
                          />
                      </div>
                  </div>
                  <div className="col-md-5">
                    <div className="form-group">
                      <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formularioAdicionarComandante.FuncaoDeBordo}:</label>
                      <Select
                      className="form-field-name"
                      name="captain_duty_id"
                      value={self.state.captain_duty_id}
                      searchable={true}
                      placeholder={''}
                      onChange={self.handleSelectChange.bind(self, 'captain_duty_id')}
                      options={self.state.captain_duties_select}
                      required
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                      <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i></button>
                  </div>
              </div>
          </form>
          <form onSubmit={this.addCopilot} className="col-md-4">
              <div className="row">
                  <div className="col-md-5">
                      <div className="form-group">
                          <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formularioAdicionarCopiloto.Copiloto}:</label>
                          <Select
                          className="form-field-name"
                          name="copilot_id"
                          value={self.state.copilot_id}
                          searchable={true}
                          placeholder={''}
                          onChange={self.handleSelectChange.bind(self, 'copilot_id')}
                          options={self.state.copilots_select}
                          required
                          />
                      </div>
                  </div>
                  <div className="col-md-5">
                    <div className="form-group">
                      <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formularioAdicionarCopiloto.FuncaoDeBordo}:</label>
                      <Select
                      className="form-field-name"
                      name="copilot_duty_id"
                      value={self.state.copilot_duty_id}
                      searchable={true}
                      placeholder={''}
                      onChange={self.handleSelectChange.bind(self, 'copilot_duty_id')}
                      options={self.state.copilot_duties_select}
                      required
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                      <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i></button>
                  </div>
              </div>
          </form>
          <form onSubmit={this.addFlightAttendant} className="col-md-4">
            <div className="row">
              <div className="col-md-5">
                <div className="form-group">
                  <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formularioAdicionarComissario.Comissario}:</label>
                  <Select
                  className="form-field-name"
                  name="flight_attendant_id"
                  value={self.state.flight_attendant_id}
                  searchable={true}
                  placeholder={''}
                  onChange={self.handleSelectChange.bind(self, 'flight_attendant_id')}
                  options={self.state.flight_attendants_select}
                  required
                  />
                </div>
              </div>
              <div className="col-md-5">
                <div className="form-group">
                  <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formularioAdicionarComissario.FuncaoDeBordo}:</label>
                  <Select
                  className="form-field-name"
                  name="flight_attendant_duty_id"
                  value={self.state.flight_attendant_duty_id}
                  searchable={true}
                  placeholder={''}
                  onChange={self.handleSelectChange.bind(self, 'flight_attendant_duty_id')}
                  options={self.state.flight_attendant_duties_select}
                  required
                  />
                </div>
              </div>
              <div className="col-md-2">
                <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i></button>
              </div>
            </div>
          </form>
        </div>
        <hr/>
        <table className="table table-bordered table-hover table-striped">
            <thead>
            <tr>
                <th>{this.locale.Escalas.SimulacaoEscalaDiaria.tabelaGrupo.Tripulante}</th>
                <th>{this.locale.Escalas.SimulacaoEscalaDiaria.tabelaGrupo.FuncaoDeBordo}</th>
                <th className="col-md-1"></th>
            </tr>
            </thead>
            <tbody>
            {Object.keys(this.state.schedule_group_staffs).map(function(ksgs) {
            var sgs = self.state.schedule_group_staffs[ksgs];
            return (
                <tr>
                <td>{sgs.staff.name}</td>
                <td>{sgs.duty.name}</td>
                <td className="text-center"><button onClick={() => {self.deleteRow(ksgs)}} className="btn btn-danger"><i className="fa fa-fw fa-trash"></i></button></td>
                </tr>
            );
            })}
            </tbody>
        </table>
        <form onSubmit={this.add}>
        <div className="row">
            <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Escalas.SimulacaoEscalaDiaria.formularioSimularProgramacao.botaoSimularProgramacao}</button>
            </div>
        </div>
        </form>
    </div>
  </div>
  <Modal show={this.state.modal_alerts} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left"><strong>{this.locale.Escalas.SimulacaoEscalaDiaria.tituloAlertas}</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false, justification: null, approve: false})}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div>
        {
          Object.keys(self.state.global_alerts).map(function(k) {
            var alert = self.state.global_alerts[k];
            if(Array.isArray(alert)) {
              return(
                <div>
                  {Object.keys(alert).map(function(klert) {
                    var alert2 = alert[klert];
                    if(alert2) {
                      if (alert2.error && alert2.error === 1) {
                        return(
                          <div className={"box-alert box-alert-" + alert2.color}>
                            <div dangerouslySetInnerHTML={{__html: alert2.message}}></div>
                          </div>
                        );
                      }
                    }
                  })}
                </div>
              );
            }
          })
        }
      </div>
      <div>
        {
          Object.keys(self.state.global_alerts).map(function(k) {
            var alert = self.state.global_alerts[k];
            if(alert) {
              if (alert.error && alert.error === 1) {
                return(
                  <div className={"box-alert box-alert-" + alert.color}>
                    <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                  </div>
                );
              }
            }
          })
        }
      </div>
      <hr/>
      <div>
        {
          Object.keys(self.state.staff_alerts).map(function(nickname) {
            var alerts = self.state.staff_alerts[nickname];
            return(
              <div>
                <h4><strong>{nickname}</strong></h4>
                {Object.keys(alerts).map(function(k) {
                  var alert = alerts[k];
                  if(alert) {
                    if (alert.error === 1) {
                      return(
                        <div className={"box-alert box-alert-" + alert.color}>
                          <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                        </div>
                      );
                    }
                  }
                })}
                <hr/>
              </div>
            );
          })
        }
      </div>
      {
        (this.state.approve === true) 
          ?
          <form onSubmit={this.approve}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>{this.locale.Escalas.SimulacaoEscalaDiaria.formularioContinuarAprovacao.Justificativa}:</label>
                  <textarea style={{ height: 200 }} type="text" name="justification" required className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-certificate"></i> {this.locale.Escalas.SimulacaoEscalaDiaria.formularioContinuarAprovacao.botaoContinuarAprovacao}</button>
                </div>
              </div>
            </div>
          </form>
          : 
          ''
      }
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false, justification: null, approve: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default SchedulePlanningSimulation;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulePlanningSimulation.js